// @flow
import { combineActions, handleActions } from 'redux-actions';
import { upsertResource, upsertResources, completeWithError } from 'data/qcsSyncResourceReducerHelpers';
import * as freeToSpendActions from 'data/freeToSpend/freeToSpendActions';
import { mkFreeToSpend } from 'data/freeToSpend/freeToSpendTypes';
import { dangerouslyUseFeatureFlags } from 'utils/featureFlags/selectors';
import * as localPreferences from 'utils/localPreferences';

import * as actions from './actions';
import { makeDatasetsStore, REDUCER_KEY as DATASETS_REDUCER_KEY } from './types';
import type { DatasetsStore } from './types';

const reducer = handleActions({

  [combineActions(
    actions.createDataset,
    actions.updateDataset,
    actions.deleteDataset,
  )]: (state) => state.merge({
    isUpserting: true,
  }),

  [combineActions(actions.getDatasetsSuccess)]:
    (state, { payload: data }) => {
      let resources;
///////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////
///////////////
///////////////////////////////////////////
      resources = data.resources.filter((dataset) => dataset.platform !== 'ACME');
///////////////
      return upsertResources(state, data.merge({ resources }));
    },

  [combineActions(
    actions.updateDatasetSuccess,
    actions.deleteDatasetSuccess,
  )]:
    (state, { payload: datasetToUpsert }) => {
      const newState = upsertResource(state, datasetToUpsert);
      return newState.merge({
        isUpserting: false,
        error: undefined,
      });
    },

  [actions.createDatasetSuccess]:
    (state, { payload: datasetToUpsert, asyncDispatch }) => {
      const featureFlags = dangerouslyUseFeatureFlags();
      if (featureFlags && featureFlags.get && featureFlags.get('spendingPlan')) {
        asyncDispatch(freeToSpendActions.createFreeToSpend(
          mkFreeToSpend({}),
          { axiosConfig: { headers: { 'qcs-dataset-id': datasetToUpsert.id } } },
        ));
      }

      localPreferences.setPollDataset(datasetToUpsert.id);

      const newState = upsertResource(state, datasetToUpsert);
      return newState.merge({
        isUpserting: false,
        error: undefined,
      });
    },

  [actions.getDatasetsFailure]:
    (state: DatasetsStore, { payload: error }) => completeWithError(state, error),

  [combineActions(
    actions.createDatasetFailure,
    actions.updateDatasetFailure,
    actions.deleteDatasetFailure,
  )]: (state: DatasetsStore, { payload: error, asyncDispatch }) => {
    asyncDispatch(actions.getDatasets());
    return (state.merge({ isUpserting: false, error }));
  },

}, makeDatasetsStore());

export const REDUCER_KEY = DATASETS_REDUCER_KEY;
export default reducer;
